/**
 * Константы контактной информации
 */
export const CONTACT_INFO = {
    phone: "+380 (66) 949-11-37",
    email: "megapoliv@gmail.com",
    address: "вул. Академіка Павлова, 142Б, корпус 3, цокольний поверх, Харків",
    coordinates: [50.01888616734991, 36.338211943225886], // Харків
    mapZoom: 15,
};

